import type { FunctionComponent } from 'react'
import React, { useContext, useState } from 'react'

import { RadioGroupPage } from '../../../../shared/pages/RadioGroupPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { HowDidYouPayFlow, WhatBankFlow } from '../../pageFlowData'
import { howDidYouPayData } from './data'

export const HowDidYouPay: FunctionComponent = () => {
  const [isInputValid, setInputValid] = useState(true)
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    victim: { howDidYouPay },
  } = state
  const [radioSelected, setRadioSelected] = useState(howDidYouPay)

  const handleChange = (id: string) => {
    setRadioSelected(id)
  }

  const handleTracking = () => {
    const trackingAnswer = `question | ${HowDidYouPayFlow.VIEW_NAME} | ${radioSelected}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = () => {
    dispatch({ type: 'UPDATE_HOW_DID_YOU_PAY', data: radioSelected })
    dispatch({ type: 'UPDATE_STEP', data: WhatBankFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: WhatBankFlow.PROGRESS_VALUE })
  }

  const handleSubmit = () => {
    if (radioSelected) {
      setInputValid(true)
      handleTracking()
      handleDispatch()
    }
    setInputValid(false)
  }

  const { buttons, title, imgObj } = howDidYouPayData

  return (
    <RadioGroupPage
      buttonText="Next"
      buttons={buttons}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      imgObj={imgObj}
      isInputValid={isInputValid}
      stateValue={radioSelected}
      title={title}
    />
  )
}
